var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonIconClose3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 19",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "place_icon_input_clear_bg",
    cx: 9,
    cy: 9.49938,
    r: 8.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "place_icon_input_clear_btn",
    d: "M11.6011 6.10049L12.0001 5.70152L12.7981 6.49947L12.3991 6.89845L9.79814 9.49939L12.3992 12.1005L12.7982 12.4995L12.0003 13.2974L11.6013 12.8985L9.00019 10.2974L6.39909 12.8985L6.00011 13.2974L5.20215 12.4995L5.60113 12.1005L8.20223 9.49939L5.60129 6.89845L5.20231 6.49947L6.00027 5.70152L6.39924 6.10049L9.00019 8.70144L11.6011 6.10049Z"
  })));
}
export default SvgCommonIconClose3;